(() => {
  const once = (selector, marker) => {
    const el = document.querySelector(selector);
    if (!el || el.dataset[marker] === 'ready') return null;
    el.dataset[marker] = 'ready';
    return el;
  };

  function enhanceGuide(){
    const guide = once('.aureko-guide', 'aurekoPremium');
    if(!guide) return;
    guide.querySelectorAll('.aureko-tool-guide-card').forEach((card,index) => {
      card.dataset.aurekoIndex = String(index + 1).padStart(2,'0');
    });
    const nav = guide.querySelector('.aureko-guide__movement-nav');
    if(!nav || guide.querySelector('.aureko-guide-standard')) return;
    nav.insertAdjacentHTML('afterend', `
      <section class="aureko-guide-standard" aria-label="The AUREKO standard">
        <div class="aureko-guide-standard__intro">
          <span class="aureko-guide-standard__eyebrow">THE AUREKO STANDARD</span>
          <h3>Natural material.<br>Clear purpose.<br>No unnecessary complexity.</h3>
          <p>The premium part is not a complicated protocol. It is choosing the right movement, using comfortable pressure and keeping a ritual simple enough to repeat.</p>
        </div>
        <div class="aureko-guide-standard__grid">
          <article><b>01</b><strong>Natural wood</strong><p>Warm, tactile forms that feel at home in an intentional body-care routine.</p></article>
          <article><b>02</b><strong>Movement first</strong><p>Roll, glide or press — choose by how you want the tool to move across the body.</p></article>
          <article><b>03</b><strong>Built your way</strong><p>Choose any combination and repeat the tools you know you will actually use.</p></article>
        </div>
      </section>`);
  }

  function enhanceHome(){
    const home = once('.aureko-home', 'aurekoPremium');
    if(!home) return;
    const marquee = home.querySelector('.aureko-marquee');
    if(!marquee || home.querySelector('.aureko-home-standard')) return;
    marquee.insertAdjacentHTML('afterend', `
      <section class="aureko-home-standard" aria-label="The AUREKO standard">
        <div class="aureko-home-standard__intro"><span>THE AUREKO STANDARD</span><h2>Premium should feel clear, not loud.</h2></div>
        <div class="aureko-home-standard__grid">
          <article><b>01</b><strong>Natural wood</strong><p>Warm material and sculptural forms for an elevated at-home body-care ritual.</p></article>
          <article><b>02</b><strong>Intentional use</strong><p>Simple movements, comfortable pressure and a routine designed around your pace.</p></article>
          <article><b>03</b><strong>Secure purchase</strong><p>Checkout runs through Shopify, with available payment methods confirmed at checkout.</p></article>
        </div>
      </section>`);
  }

  function enhanceProduct(){
    const note = once('.aureko-checkout-note', 'aurekoPremium');
    if(!note || document.querySelector('.aureko-product-confidence')) return;
    note.insertAdjacentHTML('afterend', `
      <div class="aureko-product-confidence" aria-label="Purchase confidence">
        <div class="aureko-product-confidence__item"><b>Natural wood</b><span>Warm, tactile body-care tools</span></div>
        <div class="aureko-product-confidence__item"><b>Secure checkout</b><span>Checkout powered by Shopify</span></div>
        <div class="aureko-product-confidence__item"><b>Clear returns</b><a href="/pages/returns-and-refunds">Read the returns policy</a></div>
        <div class="aureko-product-confidence__item"><b>Need help?</b><a href="/pages/contact">Contact AUREKO</a></div>
      </div>`);
  }

  function enhanceCart(){
    const summary = once('.aureko-cart-summary', 'aurekoPremium');
    if(!summary || summary.querySelector('.aureko-cart-confidence')) return;
    const target = summary.querySelector('.aureko-cart-secure');
    const panel = document.createElement('div');
    panel.className = 'aureko-cart-confidence';
    panel.innerHTML = '<div><i></i><span>Secure checkout powered by Shopify</span></div><div><i></i><span>Clear returns policy and customer support</span></div>';
    if(target) target.before(panel); else summary.appendChild(panel);
  }

  const init = () => { enhanceGuide(); enhanceHome(); enhanceProduct(); enhanceCart(); };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
